<template>
  <div class="d-flex p-5 width">
    <marketer-sidebar />
    <div class="w-100">
      <form class="w-100" @submit.prevent="update">
        <p class="h4 mb-4">プロフィール編集</p>
        <div class="pb-5 text-center">
          <template v-if="cropping">
            <vue-cropper ref="cropper" :src="cropsrc" :aspect-ratio="1"></vue-cropper>
            <mdb-row>
              <mdb-col>
                <mdb-btn class="btn btn-indigo" @click="crop">切り取り</mdb-btn>
                <mdb-btn class="btn mt-2" @click="cropping = false">取り消し</mdb-btn>
              </mdb-col>
            </mdb-row>
          </template>
          <template v-else>
            <img class="profile" :src="profile_img" @click="file.click()" alt="">
            <mdb-row>
              <mdb-col>
                <a href="javascript:void(0)" @click="file.click()" class="change-image">写真を変更</a>
                <input ref="file" type="file" accept="image/*" @change="uploadFile" />
              </mdb-col>
            </mdb-row>
          </template>
        </div>
        <div class="pb-5">
          <label for="defaultFormLoginEmailEx" class="grey-text pb-1">表示名 <small>※未記入の場合、企業には登録Noが表示されます</small></label>
          <mdb-row>
            <mdb-col>
              <mdb-input
                type="text"
                v-model="profile.display_name" />
            </mdb-col>
            <mdb-col></mdb-col>
          </mdb-row>
        </div>
        <div class="pb-5">
          <label for="defaultFormLoginPasswordEx" class="grey-text pb-1">名前<mdb-badge color="danger">必須</mdb-badge></label>
          <mdb-row>
            <mdb-col ><mdb-input type="text" v-model="profile.family_name" required/></mdb-col>
            <mdb-col ><mdb-input type="text" v-model="profile.first_name" required/></mdb-col>
          </mdb-row>
        </div>
        <div class="pb-5">
          <label for="defaultFormLoginPasswordEx" class="grey-text pb-1">ふりがな<mdb-badge color="danger">必須</mdb-badge></label>
          <mdb-row>
            <mdb-col><mdb-input type="text" v-model="profile.family_name_kana" required/></mdb-col>
            <mdb-col><mdb-input type="text" v-model="profile.first_name_kana" required/></mdb-col>
          </mdb-row>
        </div>
        <div class="pb-5">
          <label for="defaultFormLoginPasswordEx" class="grey-text pb-1">希望の働き方<mdb-badge color="danger">必須</mdb-badge></label>
          <button-radio :data="working_types" name="working_type" v-model="profile.working_type" />
        </div>
        <div class="pb-5">
          <label for="defaultFormLoginPasswordEx" class="grey-text pb-1">WEBマーケティング歴<mdb-badge color="danger">必須</mdb-badge></label>
          <select class="p-2 mx-2 w-auto form-select" v-model="profile.marketing_years" required>
            <option :value="undefined" disabled>選択してください</option>
            <option :value="1">1年</option>
            <option :value="2">2年</option>
            <option :value="3">3年</option>
            <option :value="4">4年</option>
            <option :value="5">5年</option>
            <option :value="6">6年</option>
            <option :value="7">7年</option>
            <option :value="8">8年</option>
            <option :value="9">9年</option>
            <option :value="10">10年以上</option>
          </select>
        </div>
        <div class="pb-5">
          <label for="defaultFormLoginPasswordEx" class="grey-text pb-1">性別<mdb-badge color="danger">必須</mdb-badge></label>
          <button-radio name="gender" :data="genders" v-model="profile.gender" />
        </div>
        <div class="pb-5">
          <label for="defaultFormLoginPasswordEx" class="grey-text pb-1">生年月日<mdb-badge color="danger">必須</mdb-badge></label>
          <div class="d-flex">
            <select class="p-2 mx-2 form-select" id="defaultFormRegisterBirthDay" v-model="year">
              <option :value="undefined" disabled>----</option>
              <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
            </select>
            <span class="mt-2">年</span>
            <select class="p-2 mx-2 form-select" v-model="month">
              <option :value="undefined" disabled>--</option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
              <option>9</option>
              <option>10</option>
              <option>11</option>
              <option>12</option>
            </select>
            <span class="mt-2">月</span>
            <select class="p-2 mx-2 form-select" v-model="day">
              <option :value="undefined" disabled>--</option>
              <option v-for="d in days" :key="d" :value="d">{{ d }}</option>
            </select>
            <span class="mt-2">日</span>
          </div>
        </div>
        <div class="pb-5">
          <label for="defaultFormLoginPasswordEx" class="grey-text pb-1">居住地（都道府県）<mdb-badge color="danger">必須</mdb-badge></label>
          <select class="p-2 mx-2 form-select" v-model="profile.prefecture_id" required>
            <option :value="undefined" disabled>都道府県</option>
            <option v-for="pref in prefectures" :key="pref.id" :value="pref.id">{{ pref.name }}</option>
          </select>
        </div>
        <div class="text-center mt-4">
          <mdb-row>
            <mdb-col><mdb-btn
                type="submit"
                class="btn btn-indigo">保存する</mdb-btn>
            </mdb-col>
          </mdb-row>
        </div>
      </form>
    </div>
    <mdb-alert v-model="updated" color="success" position="top-right" autohide :delay="1000">更新が完了しました。</mdb-alert>
  </div>
</template>

<style scoped>
input[type=file] {
  display: none;
}

img.profile {
  cursor: pointer;
  border-radius: 50%;
  width: 160px;
  height: 160px;
}
</style>

<style>
.cropper-crop-box, .cropper-view-box {
    border-radius: 50%;
}

.cropper-view-box {
    box-shadow: 0 0 0 1px #39f;
    outline: 0;
}
.change-image {
  color: #999
}
</style>

<script>
import { ref, computed, watchEffect } from "vue";
import VueCropper from 'vue-cropperjs';
import http from "axios";
import dayjs from "dayjs";
import { usePrefecture } from "@/common/master";
import marketer_filters, { useMarketer, working_types, available_days, genders } from "@/common/marketer";
import MarketerSidebar from "@/components/marketer/sidebar.vue";

import 'cropperjs/dist/cropper.css';

export default {
  layout: "marketer",
  components: {
    MarketerSidebar,
    VueCropper,
  },
  setup() {
    const { marketer: profile } = useMarketer();

    const updated = ref(false);
    const update = async () => {
      const d = new Date(year.value, month.value-1, day.value);
      profile.value.birthday = dayjs(d).toISOString();
      await http.post('/api/marketer/me', profile.value);
      updated.value = true;
    };

    const profile_img = computed({
      get: () => { return profile.value.icon || "/app/image/icon-none-large.png" },
      set: (val) => { profile.value.icon = val }
    });
    const cropper = ref(null);
    const cropping = ref(false);
    const file = ref(null);
    const cropsrc = ref("");
    const uploadFile = (e) => {
      const f = e.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        cropsrc.value = reader.result;
        cropping.value = true;
      };
      reader.readAsDataURL(f);
    };
    const crop = () => {
      profile_img.value = cropper.value.getCroppedCanvas().toDataURL();
      cropping.value = false;
    };

    const { prefectures } = usePrefecture();

    const year = ref(1980);
    const years = ref(Array.from(Array(120).keys()).map(i => 1900 + i));
    const month = ref(1);
    const day = ref(1);
    const days = computed(() => {
      const d = new Date(year.value, month.value-1, 1);
      return Array.from(Array(dayjs(d).daysInMonth()).keys()).map(i => i + 1);
    });

    watchEffect(() => {
      if (!profile.value.birthday) return;
      let d = dayjs(profile.value.birthday);
      year.value = d.year();
      month.value = d.month() + 1;
      day.value = d.date();
    });

    return {
      profile, ...marketer_filters, updated, update,
      cropper, cropping, profile_img, file, cropsrc, uploadFile, crop,
      working_types, available_days, prefectures, genders,
      years, days, year, month, day,
    };
  }
};
</script>